import validate from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/middleware/auth.global.js";
import manifest_45route_45rule from "/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "login-redirect": () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/middleware/loginRedirect.js"),
  superadmin: () => import("/builds/anketa-cvut-v3/admin-v3/survey_admin_frontend/middleware/superadmin.js")
}